import { render, staticRenderFns } from "./FcStaticImages.vue?vue&type=template&id=3ea51051&scoped=true&"
import script from "./FcStaticImages.vue?vue&type=script&lang=ts&"
export * from "./FcStaticImages.vue?vue&type=script&lang=ts&"
import style0 from "./FcStaticImages.vue?vue&type=style&index=0&id=3ea51051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea51051",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
